(function () {
  function initHero(root) {
    if (!root || root.dataset.papisHeroReady) return;
    root.dataset.papisHeroReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.papis-hero__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.papis-hero__dot'));
    if (slides.length < 2) return;

    var index = 0;
    var interval = parseInt(root.dataset.interval, 10) || 5000;
    var pauseOnHover = root.dataset.pauseOnHover !== 'false';
    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(next) {
      slides[index].classList.remove('is-active');
      if (dots[index]) dots[index].classList.remove('is-active');
      index = (next + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      if (dots[index]) dots[index].classList.add('is-active');
    }

    function start() {
      if (reduceMotion) return;
      stop();
      timer = window.setInterval(function () {
        goTo(index + 1);
      }, interval);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var target = parseInt(dot.getAttribute('data-go'), 10);
        if (!isNaN(target)) {
          goTo(target);
          start();
        }
      });
    });

    if (pauseOnHover) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
    }

    start();
  }

  function boot() {
    document.querySelectorAll('.papis-hero').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var hero = event.target.querySelector('.papis-hero');
    if (hero) {
      delete hero.dataset.papisHeroReady;
      initHero(hero);
    }
  });
})();
